import { Injectable } from '@angular/core';
import { AuthResponse, UserRole } from './auth.models';

@Injectable({ providedIn: 'root' })
export class TokenService {
  private readonly tokenKey = 'fp_token';
  private readonly userKey = 'fp_username';
  private readonly roleKey = 'fp_role';
  private readonly requiresPasswordKey = 'fp_requires_password_change';
  private readonly requiresPolicyKey = 'fp_requires_policy_acceptance';

  saveSession(response: AuthResponse): void {
    localStorage.setItem(this.tokenKey, response.token);
    localStorage.setItem(this.userKey, response.username);
    localStorage.setItem(this.roleKey, response.rol);
    const isCliente = response.rol === 'CLIENTE';
    localStorage.setItem(this.requiresPasswordKey, String(isCliente && (!!response.requiereCambioPassword || response.primerLogin === 1)));
    localStorage.setItem(this.requiresPolicyKey, String(isCliente && !!response.requiereAceptarPoliticaDatos));
  }

  token(): string | null {
    return localStorage.getItem(this.tokenKey);
  }

  username(): string | null {
    return localStorage.getItem(this.userKey);
  }

  role(): UserRole | null {
    return localStorage.getItem(this.roleKey) as UserRole | null;
  }

  isAuthenticated(): boolean {
    return !!this.token();
  }

  requiresPasswordChange(): boolean {
    return localStorage.getItem(this.requiresPasswordKey) === 'true';
  }

  requiresPolicyAcceptance(): boolean {
    return localStorage.getItem(this.requiresPolicyKey) === 'true';
  }

  markPasswordChanged(): void {
    localStorage.setItem(this.requiresPasswordKey, 'false');
  }

  markPolicyAccepted(): void {
    localStorage.setItem(this.requiresPolicyKey, 'false');
  }

  clear(): void {
    localStorage.removeItem(this.tokenKey);
    localStorage.removeItem(this.userKey);
    localStorage.removeItem(this.roleKey);
    localStorage.removeItem(this.requiresPasswordKey);
    localStorage.removeItem(this.requiresPolicyKey);
  }
}
